import React, {FC} from 'react';
import user from '../../assets/images/icon-page/users.png';


const UserIcon: FC<{ size?: number | string; alt?: string }> = ({size = 24, alt = 'User Icon'}) => {
    return (
        <img
            src={user}
            alt={alt}
            style={{width: size, height: size, display: 'block'}}
        />
    );
};

export default UserIcon;
